let appVersion: string = 'unknown'

export const getAppVersion = async (): Promise<string> => {
  if (appVersion !== 'unknown') {
    return appVersion
  }

  try {
    const response = await fetch('/version.json', {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0'
      }
    })
    const data = await response.json()
    appVersion = data.version
    return appVersion
  } catch (error) {
    console.error('Failed to fetch app version:', error)
    return 'unknown'
  }
}

export const getStoredAppVersion = (): string => {
  return appVersion
}
